<template>
  <div class="Collapsable">
    <div class="Collapsable-Title-Wrapper">
      <img :src="icon" class="img-icon" width="30" height="30" />
      <div class="Collapsable-Title">
        {{ title }}
      </div>

      <div class="Collapsable-Toggle" @click="toggleContent" v-bind:class="{ 'Collapsable-Toggle--open': showContent }"/>
    </div>


    <div v-if="showContent" class="Collapsable-Content">
      <slot />
    </div>
  </div>
</template>

<script>
import adresse from '@/assets/icons/adresse.png'
import panier from '@/assets/icons/panier.png'

export default {
  name: 'VvCollapsable',
  data: () => ({
    showContent: true
  }),
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    icon () {
      if (this.name === 'panier') return panier

      if (this.name === 'adresse' || this.name === 'facturation') return adresse

      return null
    }
  },
  methods: {
    toggleContent() {
      this.showContent = !this.showContent
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/_variables.scss';

.Collapsable {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 46px;
  width: 75%;

  @media (max-width: 768px) {
    width: 90%;
  }
}

.img-icon {
  margin-left: 25px;
  margin-right: 10px;
  padding-bottom: 7px;
}

.Collapsable-Title-Wrapper {
  display: flex;
  flex-direction: row;
  background-color: $primary-alt;
  border-radius: 31px;
  height: 61px;
  align-items: center;
}

.Collapsable-Title {
  font-size: 30px;
  font-weight: bold;

  @media (max-width: 768768px) {
    font-size: 18px;
  }
}

.Collapsable-Toggle {
  margin-left: auto;
  margin-right: 30px;
  border-left: 4px solid black;
  border-bottom: 4px solid black;
  width: 15px;
  height: 15px;
  transform: rotate(-45deg);
  cursor: pointer;

  &--open {
    transform: rotate(135deg);
  }
}

.Collapsable-Content {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  margin-top: 85px;
  margin-bottom: 107px;

  @media (max-width: 768px) {
    // margin-left: 0;
    // margin-right: 0;
    margin-top: 10px;
    width: 90%;
  }
}
</style>